import React, { ReactNode, forwardRef } from 'react';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { Action, ActionFooter } from '../action-footer';
import { Popover } from './popover';

interface Props extends ClassNameOnlyProps {
  title: ReactNode;
  confirmationText: ReactNode;
  ok: Action;
  cancel: Action;
  reverseCta?: boolean;
}

export const ConfirmationPopover = forwardRef<HTMLDivElement, Props>(
  ({ confirmationText, title, ok, cancel, reverseCta, className }, ref) => (
    <Popover className={className} ref={ref}>
      <Popover.Title>{title}</Popover.Title>
      <Popover.Content>{confirmationText}</Popover.Content>
      <Popover.Divider />
      <ActionFooter reverse={reverseCta} primary={ok} other={[cancel]} />
    </Popover>
  ),
);
